import React from 'react'
import styled from '@emotion/styled'
import appBodyImageSrc from '../../core/assets/app-body.svg'

// App-wide decorative background (same asset the Account Management redesign
// introduced). Fixed to the viewport so it stays put while <main> scrolls;
// z-index: -1 keeps it behind everything, and AppContainer's `isolation:
// isolate` scopes that to the shell so no ancestor background can cover it.
const Image = styled.img`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: -1;
  pointer-events: none;

  @media print {
    display: none;
  }
`

export function AppBackground() {
  return <Image src={appBodyImageSrc} alt="" aria-hidden="true" />
}
